module.exports = __webpack_public_path__ + "static/media/sostenibilidad2020.4bdbaad9.pdf";